<template>
  <div>
    <div
      class="d-flex mt-3"
    >
      <div
        class="titre-h3 align-self-center  mb-1 ml-2"
      >
        Saisir les ventes de l'adhérent
      </div>
      <AgrButton
        class="align-self-center"
        icon
        @click="isOpenModalHelp = true"
      >
        <v-icon color="primary">
          mdi-information
        </v-icon>
      </AgrButton>
    </div>
    <div
      class="intro ml-2"
    >
      Retrouvez ici l'ensemble des contrats. Ajoutez si besoin les ventes sur pied et autoconsommation.
    </div>
    <div
      v-if="isBandeauGraineAffiche"
      :class="[$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-space-between ml-1 mb-3', !$vuetify.breakpoint.mobile ? 'mt-2' : '']"
      class="d-flex"
    >
      <div class="mt-3">
        <BaseSelectAnneeRecolte
          :annee-recolte-selected="anneeSelected"
          :code-graine-selected="codeGraineCulturialSelected"
          :liste-annees-recoltes="listeAnneesRecoltes"
          :liste-graines-a-afficher="grandesCulturesSorted"
          :loading="loading.anneeRecolte"
          :has-choix-toutes-cultures="false"
          @selectAnneeRecolte="selectRecolte"
          @selectGraine="selectGraine"
        />
      </div>
    </div>
    <BaseLoader v-if="loading.anneeRecolte || loading.contrats" />
    <BaseMessageServerError v-if="erreur.contrats" />
    <ResumeContrats
      v-if="!loading.anneeRecolte && !loading.contrats && !erreur.contrats"
      class="mt-2"
      :contrat="contractualisation"
      :loading="loading.contrats"
    />
    <v-row v-if="!loading.anneeRecolte && !loading.contrats">
      <v-col
        v-for="(contrat, index) in contratsVenteSorted"
        :key="index"
        cols="12"
        md="3"
      >
        <v-card
          class="eq-height pr-2"
        >
          <ContratRestitution
            :contrat="contrat"
            :code-graine-selected="codeGraineCulturialSelected"
            :loading-delete=" loading.delete"
            @modifier="onOpenModalEditContrat(contrat)"
            @repartirPoids="onOpenModalRepartitionPoids(contrat)"
            @supprimer="onOpenDeleteContratModal(contrat)"
            @confirmer="onUpdateContrat(contrat)"
          />
        </v-card>
      </v-col>
      <v-col v-if="!loading.anneeRecolte && !erreur.contrats">
        <AgrButton
          v-if="$roles.hasDroitEcritureAdminDte()"
          color="primary"
          large
          :block="$vuetify.breakpoint.mobile"
          @click="onOpenModalEditContrat()"
        >
          <v-icon>mdi-plus</v-icon>
          <span class="action text-truncate white--text">Ajouter une vente</span>
        </AgrButton>
      </v-col>
    </v-row>
    <HelpModal
      v-if="isOpenModalHelp"
      titre="Saisir les ventes de l'adhérent"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte texte-gris-fonce pa-4">
          <p>Retrouvez ici l'ensemble des ventes de l'adhérent.</p>
          <p><span class="black--text">Prix ferme sans option : </span>Prix de marché, Terme moisson.</p>
          <p><span class="black--text">Prix ferme avec option : </span>Prix minimum garanti, Agri'call.</p>
          <p><span class="black--text">Gestion déléguée : </span>Prix de campagne, Septembre-avril, Novembre-mai.</p>
          <p><span class="black--text">Echanges ou autoconso. : </span>Echanges céréales semences, céréales-aliments, autoconsommation.</p>
          <p><span class="black--text">Filières : </span>Maïs waxy, blé noir tradition Bretagne, etc...</p>
          <p><span class="black--text">Autres : </span>Ventes sur pied, autres ventes.</p>
        </div>
      </div>
    </HelpModal>
    <v-dialog
      v-model="isOpenModalEditContrat"
      :scrim="false"
      fullscreen
      transition="slide-x-transition"
      @click:outside="onCloseModalEditContrat"
    >
      <SaisieContratAdherentModal
        :contrat="contratSelected"
        :contrats-vente="contratsVenteSorted"
        :type-culture-selected="typeCultureSelected"
        @reload="loadContrats()"
        @close="onCloseModalEditContrat"
      />
    </v-dialog>
    <v-dialog
      v-model="isOpenModalRepartitionPoids"
      :scrim="false"
      fullscreen
      transition="slide-x-transition"
      @click:outside="onCloseModalRepartitionPoidsContrat"
    >
      <RepartitionContratAdherentModal
        :contrat="contratSelected"
        @reload="loadContrats()"
        @close="onCloseModalRepartitionPoidsContrat"
      />
    </v-dialog>
    <v-dialog
      v-model="isConfirmDeleteContratModalOpen"
      persistent
      width="500"
    >
      <ConfirmModal
        cancel-text="Non"
        confirm-text="Oui"
        title="Confirmation"
        :loading="loading.contrats"
        @cancel="cancelConfirmDeleteContrat"
        @confirm="confirmDeleteContrat"
      >
        <p>Attention, vous souhaitez supprimer le contrat.</p>
        <p>Voulez-vous vraiment continuer ?</p>
      </ConfirmModal>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {orderBy } from 'lodash'
import { AgrButton } from '@agrial/ui'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import BaseSelectAnneeRecolte from '@/components/common/base-select-annee-recolte.vue'
import ConfirmModal from '@/components/modal/confirm-modal.vue'
import ContratRestitution from './components/contrat-restitution.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import RepartitionContratAdherentModal from './components/modal/repartition-contrat-adherent-modal.vue'
import ResumeContrats from './components/resume-contrats.vue'
import SaisieContratAdherentModal from '@/views/outils-analyse/saisie-contrats/components/modal/saisie-contrat-adherent-modal.vue'

export default {
  name: 'SaisieContratsAdherent',

  components: {AgrButton, BaseLoader, BaseMessageServerError, BaseSelectAnneeRecolte, ConfirmModal, ContratRestitution, HelpModal, RepartitionContratAdherentModal, ResumeContrats, SaisieContratAdherentModal},
  data () {
    return {
      isFromPageSansGraineRs3: false,
      loading: {
        anneeRecolte: false,
        contrats: false,
        confirm: false,
        delete: false
      },
      erreur: {
        anneeRecolte: false,
        contrats: false,
        grainesRs3: false,
        confirm: false
      },
      anneeSelected: null,
      codeGraineCulturialSelected: null,
      isOpenModalEditContrat: false,
      isOpenModalRepartitionPoids: false,
      contratSelected: null,
      isConfirmDeleteContratModalOpen: false,
      isOpenModalHelp: false
    }
  },
  computed: {
    ...mapGetters({
      adherent: 'adherent/adherent',
      anneeRecolteEnCours: 'application/anneeRecolteEnCours',
      anneeRecolteActive: 'application/anneeRecolteActive',
      grainesRs3:'application/grainesRs3',
      codeGraineActive: 'application/codeGraineActive',
      contractualisation:'contratVente/contractualisation',
      grainesContractualiseesEtRecoltees: 'graine/grainesContractualiseesEtRecoltees',
      listeAnneesRecoltes: 'recolte/listeAnneesRecoltes',
      cultures: 'culture/cultures',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet',
    }),
    isBandeauGraineAffiche () {
      return this.grandesCulturesSorted && this.grandesCulturesSorted.length > 0
    },
    typeCultureSelected () {
      return this.cultures.find(c => c.typeCulture.code === this.codeGraineCulturialSelected)?.typeCulture
    },
    grandesCulturesSorted () {
      return orderBy(this.cultures.filter(c => c.typeCulture.codeTypeCultureParent === 'GC' && c.surfaceEnHectare!= null), ['surfaceEnHectare'], ['desc']).map(c => {
        return { code: c.typeCulture.code, libelle: c.typeCulture.nom, surface: c.surfaceEnHectare }
      })
    },
    contratsVenteSorted () {
      let result  = this.contractualisation!= null && this.contractualisation.contratVentes!= null && this.contractualisation.contratVentes.length ? this.contractualisation.contratVentes : []
      return result.sort((a, b) => (b.contratAgrial - a.contratAgrial))
    }
  },

  created () {
    this.loading.anneeRecolte = true
    this.anneeSelected = this.anneeRecolteActive != null ? this.anneeRecolteActive : this.anneeRecolteEnCours
    if (this.adherent.numtiers != null) {
      this.fetchRecoltesContractualiseesEtRecoltees()
        .then(() => {
          this.loadGrainesCulturial()
        })
    } else {
      this.loading.anneeRecolte = false
    }
  },
  methods: {
    ...mapActions({
      updateAnneeRecolteActive: 'application/updateAnneeRecolteActive',
      updateCodeGraineActive: 'application/updateCodeGraineActive',
      fetchRecoltesContractualiseesEtRecoltees: 'recolte/fetchRecoltesContractualiseesEtRecoltees',
      getCultures: 'culture/getCultures',
      getCulturesSansMouvement: 'culture/getCulturesSansMouvement',
      getContrats: 'contratVente/getContractualisation',
      deleteContratVente: 'contratVente/deleteContratVente',
      createOrUpdateContratVente: 'contratVente/createOrUpdateContratVente'
    }),
    loadContrats () {
      this.loading.contrats = true
      this.erreur.contrats = false
        this.getContrats(this.codeGraineCulturialSelected)
        .catch(() => {
          this.erreur.contrats = true
        })
        .finally(() => {
          this.loading.contrats = false
          this.loading.delete = false
          this.loading.confirm = false
          this.isConfirmDeleteContratModalOpen = false
        })
    },
    loadGrainesCulturial () {
      this.loading.anneeRecolte = true
      this.erreur.grainesRs3 = false
      Promise.all([
        this.getCultures(this.anneeSelected),
        this.getCulturesSansMouvement(this.anneeSelected)
      ])
        .then(() => {
          this.findCodeGraineCulturialSelected()
        })
        .catch(() => {
          this.erreur.grainesRs3 = true
        })
        .finally(() => {
          this.loading.anneeRecolte = false
        })
    },
    selectGraine (codeGraine) {
      this.updateCodeGraineActive(codeGraine)
      this.codeGraineCulturialSelected = codeGraine
      this.loadContrats()
    },
    selectRecolte (anneeRecolte) {
      this.loading.anneeRecolte = true
      this.updateAnneeRecolteActive(anneeRecolte)
      this.anneeSelected = anneeRecolte
      this.loadGrainesCulturial()
    },
    findCodeGraineCulturialSelected () {
      let typeCultures = this.cultures.filter(c => c.typeCulture.codeTypeCultureParent === 'GC').map(c => c.typeCulture)
      this.codeGraineCulturialSelected = null
      typeCultures.forEach(typeCulture => {
        if (typeCulture.code === this.codeGraineActive) {
          this.codeGraineCulturialSelected = typeCulture.code
        }
        if (typeCulture.graineRs3Correspondantes.length) {
          typeCulture.graineRs3Correspondantes.forEach(graineRs3 => {
            if (graineRs3.code === this.codeGraineActive) {
              this.codeGraineCulturialSelected = typeCulture.code
            }
          })
        }
      })
      this.codeGraineCulturialSelected = this.codeGraineCulturialSelected ? this.codeGraineCulturialSelected : this.grandesCulturesSorted[0].code
      this.loadContrats()
    },
    onOpenModalEditContrat (contrat) {
      this.contratSelected = contrat != null ? contrat : {}
      this.isOpenModalEditContrat = true
    },
    onCloseModalEditContrat () {
      this.contratSelected = null
      this.isOpenModalEditContrat = false
    },
    onOpenModalRepartitionPoids (contrat) {
      this.contratSelected = contrat != null ? contrat : {}
      this.isOpenModalRepartitionPoids = true
    },
    onCloseModalRepartitionPoidsContrat () {
      this.contratSelected = null
      this.isOpenModalRepartitionPoids = false
    },
    onOpenDeleteContratModal (value) {
      this.contratSelected = value
      this.isConfirmDeleteContratModalOpen = true
    },
    confirmDeleteContrat () {
      this.loading.delete = true
      this.deleteContratVente(this.contratSelected)
        .then(() => {
          this.contratSelected = null
        })
        .finally(() => {
          this.loadContrats()
        }
      )
    },
    cancelConfirmDeleteContrat () {
      this.isConfirmDeleteContratModalOpen = false
      this.contratSelected = null
    },
    onUpdateContrat (contrat) {
      this.loading.confirm = true
      this.erreur.confirm = false
      this.createOrUpdateContratVente(contrat)
        .catch(() => {
          this.erreur.confirm = true
        })
        .finally(() => {
          this.loadContrats()
        })
    }
  }
  
}
</script>
<style lang="scss" scoped>
.position {
  position: absolute;
  top: 0;
  right: 20px;
}
</style>
